import React, { useState, useRef, useEffect } from "react";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import api from "../../Utils/api";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import { Button, Col, InputGroup, Form } from "react-bootstrap";
import { GetPre7DayDate, getCurrentDate } from "../../Utils/commonfunctions";
import {
  PrintStoneSticker,
  PrintPreviewStoneDetails,
} from "../../Utils/commonfunctions";
import ReactDOM from "react-dom";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

export default function SplitASI() {
  const [findStoneNO, setFindStoneNo] = useState("ASI-");
  const [stoneNoData, setStoneNoData] = useState([]);
  const [stoneType, setStoneType] = useState("");
  const [numOfRows, setNumOfRows] = useState(0); // Initialize to 0
  const [SplitASIList, setSplitASIList] = useState([]);
  const [totalWeight, setTotalWeight] = useState(0);
  const [stoneID, setStoneID] = useState(0);
  const [totalPcs, setTotalPcs] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [totalWidth, setTotalWidth] = useState(0);
  const [totalHeight, setTotalHeight] = useState(0);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [SplitStoneData, setSplitStoneData] = useState([]);
  const [selectedRowID, setSelectedRowID] = useState([]);

  const stoneNoRef = useRef(null);

  useEffect(() => {
    if (stoneNoRef.current) {
      stoneNoRef.current.focus();
    }
  }, []);
  const emtSearchFormData = {
    start_date: GetPre7DayDate(),
    end_date: getCurrentDate(),
  };

  // for date range picker
  const [dateData, setDateData] = useState(emtSearchFormData);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDateData({ ...dateData, [name]: value });
  };

  const getSplitStone = () => {
    api
      .get(
        `Stone/AllStoneWithASI?START_DATE=${dateData.start_date}&END_DATE=${dateData.end_date}`
      )
      .then((result) => {
        setSplitStoneData(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const FindASI = (e) => {
    if (e.key === "Enter") {
      api
        .get(`Stone/ByBagNo?ASINo=${findStoneNO}`)
        .then((result) => {
          setStoneNoData(result.data.data);
          setStoneID(result.data.data[0].stoneID);
        })
        .catch((error) => console.log(error));
    }
  };

  useEffect(() => {
    getSplitStone();
    getStoneTypeName();
  }, []);

  // Fetch Stone Type Name For Dropdown
  const getStoneTypeName = () => {
    api
      .get("StoneType/GetStoneTypeName")
      .then((result) => {
        setOptions(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRowInputChange = (index, field, value) => {
    const updatedList = [...SplitASIList];
    updatedList[index] = {
      ...updatedList[index],
      stoneID: stoneID,
      stoneType: stoneType,
      [field]: value,
    };

    // Calculate totals
    const newTotalWeight = updatedList.reduce(
      (accumulator, currentValue) =>
        accumulator + (parseFloat(currentValue.weight) || 0),
      0
    );
    const newTotalPcs = updatedList.reduce(
      (accumulator, currentValue) =>
        accumulator + (parseFloat(currentValue.pcs) || 0),
      0
    );
    const newTotalLength = updatedList.reduce(
      (accumulator, currentValue) =>
        accumulator + (parseFloat(currentValue.length) || 0),
      0
    );
    const newTotalWidth = updatedList.reduce(
      (accumulator, currentValue) =>
        accumulator + (parseFloat(currentValue.width) || 0),
      0
    );
    const newTotalHeight = updatedList.reduce(
      (accumulator, currentValue) =>
        accumulator + (parseFloat(currentValue.height) || 0),
      0
    );

    // Validate totals against searched ASI data
    if (stoneNoData.length > 0) {
      let isValid = true;
      let errorMessage = "";

      if (newTotalPcs > stoneNoData[0].pcs) {
        isValid = false;
        errorMessage = "Total PCS cannot be greater than available PCS";
      } else if (newTotalLength > stoneNoData[0].length) {
        isValid = false;
        errorMessage = "Total Length cannot be greater than available Length";
      } else if (newTotalWidth > stoneNoData[0].width) {
        isValid = false;
        errorMessage = "Total Width cannot be greater than available Width";
      } else if (newTotalHeight > stoneNoData[0].height) {
        isValid = false;
        errorMessage = "Total Height cannot be greater than available Height";
      } else if (newTotalWeight > stoneNoData[0].weight) {
        isValid = false;
        errorMessage = "Total Weight cannot be greater than available Weight";
      }

      if (!isValid) {
        // Show alert
        Swal.fire({
          icon: "error",
          title: "Invalid Input",
          text: errorMessage,
          confirmButtonColor: "#d33",
        });

        // Reset the invalid input
        updatedList[index][field] = "";
        setSplitASIList(updatedList);
        return;
      }
    }

    // Update totals
    setTotalWeight(newTotalWeight);
    setTotalPcs(newTotalPcs);
    setTotalLength(newTotalLength);
    setTotalWidth(newTotalWidth);
    setTotalHeight(newTotalHeight);

    // Update the SplitASIList
    setSplitASIList(updatedList);
  };

  // Validate number of rows against pcs
  const handleNumOfRowsChange = (e) => {
    const enteredRows = parseInt(e.target.value, 10);
    const availablePcs = stoneNoData[0]?.pcs || 0;

    if (enteredRows > availablePcs) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Number of rows cannot be greater than available pcs",
        confirmButtonColor: "#d33",
      });
    } else {
      setNumOfRows(enteredRows);
      setSplitASIList([]);
    }
  };

  const InsertSplitStone = () => {
    if (!stoneType) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please select stone type",
        confirmButtonColor: "#d33",
      });
      return;
    }
    const totalPcs = SplitASIList.reduce(
      (sum, item) => sum + (parseFloat(item.pcs) || 0),
      0
    );
    const totalLength = SplitASIList.reduce(
      (sum, item) => sum + (parseFloat(item.length) || 0),
      0
    );
    const totalWidth = SplitASIList.reduce(
      (sum, item) => sum + (parseFloat(item.width) || 0),
      0
    );
    const totalHeight = SplitASIList.reduce(
      (sum, item) => sum + (parseFloat(item.height) || 0),
      0
    );
    const totalWeight = SplitASIList.reduce(
      (sum, item) => sum + (parseFloat(item.weight) || 0),
      0
    );

    if (
      totalPcs != stoneNoData[0].pcs ||
      totalLength != stoneNoData[0].length ||
      totalWidth != stoneNoData[0].width ||
      totalHeight != stoneNoData[0].height ||
      totalWeight != stoneNoData[0].weight
    ) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Total PCS, Length, Width, Height or Weight does not match with the available values",
        confirmButtonColor: "#d33",
      });
      return;
    }
    setIsLoading(true);
    api
      .post(`Stone/InsertSplitASI`, SplitASIList)
      .then((result) => {
        setIsLoading(false);
        stoneNoRef.current.focus();
        getSplitStone();
        restData();
        setFindStoneNo("ASI-");
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Split ASI saved successfully",
          confirmButtonColor: "#28a745",
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const restData = () => {
    setStoneType("");
    setNumOfRows([]);
    setStoneNoData([]);
    setFindStoneNo("");
  };

  const handleCheckboxSelection = (event) => {
    setSelectedRowID([]);
    const selectedRows = event.api.getSelectedRows();
    const selectedRowIDs = Array.isArray(selectedRows)
      ? selectedRows.map((row) => row.stoneNo)
      : [];
    setSelectedRowID(selectedRowIDs);
  };

  const printSelectedRows = () => {
    api
      .post(`Stone/PrintMultiStoneSticker`, selectedRowID)
      .then((result) => {
        const selectedStonesData = result.data.data;
        HandelPrintStone(selectedStonesData);
        setSelectedRowID([]);
        getSplitStone();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const HandelPrintStone = (selectedStonesData) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow.document;
    iframeDocument.write(
      '<html><head><style>@page{margin: 0;}</style><title>Report</title><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"></head><body>'
    );
    ReactDOM.render(
      <>
        {selectedStonesData.map((stoneDetail, index) => (
          <React.Fragment key={index}>
            <PrintPreviewStoneDetails stoneDetail={stoneDetail} />
          </React.Fragment>
        ))}
      </>,
      iframeDocument.body
    );
    iframeDocument.write("</body></html>");
    iframeDocument.close();
    iframe.contentWindow.print();
    // setTimeout(() => {
    //   document.body.removeChild(iframe);
    // }, 1000);
  };

  const exportToExcel = () => {
    setIsLoading(true);

    setTimeout(async () => {
      try {
        const fileName = "SplitASI.xlsx";

        // Format the data to be exported
        const formattedData = SplitStoneData.map((item) => ({
          StoneNo: item.stoneNo,
          Pcs: item.pcs,
          StoneType: item.stoneType,
          Length: item.length,
          Width: item.width,
          Height: item.height,
          Weight: item.weight,
        }));

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Split ASI");

        // Set up the columns
        worksheet.columns = [
          { header: "Stone No", key: "StoneNo", width: 20 },
          { header: "Stone Type", key: "StoneType", width: 20 },
          { header: "PCS", key: "Pcs", width: 10 },
          { header: "Length", key: "Length", width: 15 },
          { header: "Width", key: "Width", width: 15 },
          { header: "Height", key: "Height", width: 15 },
          { header: "Weight", key: "Weight", width: 15 },
        ];

        // Add the rows to the worksheet
        worksheet.addRows(formattedData);

        // Style the header row
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF4F81BD" },
          };
          cell.alignment = { horizontal: "center", vertical: "middle" };
        });

        // Adjust column widths based on content length
        worksheet.columns.forEach((column) => {
          let maxLength = column.header.length;
          formattedData.forEach((row) => {
            const cellValue = row[column.key];
            if (cellValue) {
              maxLength = Math.max(maxLength, cellValue.toString().length);
            }
          });
          column.width = maxLength + 2; // Add padding
        });

        // Export the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        // Handle any error here, such as showing an error message to the user
      } finally {
        setIsLoading(false);
      }
    }, 1000);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      width: 50,
      headerClass: "centered-header",
      pinned: "left",
    },
    {
      headerName: "Stone No",
      field: "stoneNo",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Pcs",
      field: "pcs",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Stone Type",
      field: "stoneType",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Length",
      field: "length",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },
    {
      headerName: "Width",
      field: "width",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },
    {
      headerName: "Height",
      field: "height",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },
    {
      headerName: "Weight",
      field: "weight",
      width: "195px",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },

    // {
    //     headerName: "Attached",
    //     field: "batchNo",
    //     width: "150px",
    //     cellStyle: { textAlign: "center" },
    //     headerClass: "center-text widthTableColum",
    //     cellRenderer: ({ value, data }) => (
    //         <ion-icon
    //             name="attach-outline"
    //             class="iconsFonts attachIcon"
    //             onClick={() => popUpForImage(data)}
    //         ></ion-icon>
    //     ),
    // },
    // {
    //     headerName: "View",
    //     field: "batchNo",
    //     width: "100px",
    //     cellStyle: { textAlign: "center" },
    //     headerClass: "center-text widthTableColum",
    //     cellRenderer: ({ value, data }) => (
    //         <ion-icon
    //             name="eye-outline"
    //             class="iconsFonts attachIcon"
    //             onClick={() => popUpForViewImage(data.stoneNo)}
    //         ></ion-icon>
    //     ),
    // },
    // {
    //     headerName: "Print",
    //     width: 100,
    //     field: "stoneNo",
    //     cellStyle: { textAlign: "center" },
    //     headerClass: "centered-header",
    //     cellRenderer: ({ value, data }) => (
    //         <ion-icon
    //             name="print-outline"
    //             class="iconsFonts"
    //             // onClick={() => PrintStoneSticker(data.stoneNo, data.stoneProcessNo)}
    //             onClick={() => PrintStoneSticker(data.stoneNo, data.stoneProcessNo)}
    //         ></ion-icon>
    //     ),
    // },
    // {
    //     headerName: "Edit",
    //     width: 100,
    //     field: "stoneID",
    //     cellStyle: { textAlign: "center" },
    //     headerClass: "centered-header",
    //     cellRenderer: ({ value }) => (
    //         <ion-icon
    //             name="create-outline"
    //             class="iconsFonts editIcon"
    //             onClick={() => editSplitStoneModal(value)}
    //         ></ion-icon>
    //     ),
    // },
    // {
    //     headerName: "Delete",
    //     width: 100,
    //     field: "stoneID",
    //     cellStyle: { textAlign: "center" },
    //     headerClass: "centered-header",
    //     cellRenderer: ({ value }) => (
    //         <ion-icon
    //             name="trash-outline"
    //             class="iconsFonts deleteIcon"
    //             onClick={() => deleteSplitStone(value)}
    //         ></ion-icon>
    //     ),
    // },
  ];

  return (
    <div className="card">
      <div className="card-header">
        <span>New Split ASI</span>
      </div>
      <div className="card-body">
        <div className="row col-md-12 mt-4">
          <div className="col-md-6">
            <div className="col-md-12 d-flex align-items-center mt-4">
              <div className="col-md-4">
                <label
                  htmlFor="stone_no"
                  className="form-label"
                  style={{ marginRight: "20px" }}
                >
                  ASI No:
                </label>
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control"
                  id="stone_no"
                  placeholder="Type Stone No"
                  value={findStoneNO}
                  onChange={(e) => setFindStoneNo(e.target.value)}
                  onKeyDown={FindASI}
                  ref={stoneNoRef}
                />
              </div>
            </div>
            <div className="col-md-12 d-flex align-items-center mt-4">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <label
                  htmlFor="StoneType"
                  className="form-label"
                  style={{ marginRight: "20px" }}
                >
                  Stone Type:
                </label>
              </div>
              <div className="col-md-8 col-sm-8 col-lg-8">
                <select
                  className="form-control"
                  name="Stone_Type"
                  value={stoneType}
                  onChange={(e) => setStoneType(e.target.value)}
                >
                  <option value="0">--Select Stone Type--</option>
                  {options.map((option) => (
                    <option key={option.text} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-12 d-flex align-items-center mt-4">
              <div className="col-md-4 col-sm-4 col-lg-4">
                <label
                  htmlFor="numOfRows"
                  className="form-label"
                  style={{ marginRight: "20px" }}
                >
                  Enter the NumOfRows:
                </label>
              </div>
              <div className="col-md-8 col-sm-8 col-lg-8">
                <input
                  type="number"
                  className="form-control"
                  id="numOfRows"
                  placeholder="Enter the NumOfRows"
                  value={numOfRows}
                  onChange={handleNumOfRowsChange}
                />
              </div>
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-center">
            {stoneNoData.length > 0 && (
              <div className="card" style={{ borderColor: "blue" }}>
                <h4
                  className="card-title"
                  style={{
                    textAlign: "center",
                    backgroundColor: "#20336b",
                    color: "wheat",
                  }}
                >
                  {stoneNoData[0].stoneNo}
                </h4>
                <div className="card-body table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Stone Type</th>
                        <th>Pcs</th>
                        <th>Length</th>
                        <th>Width</th>
                        <th>Height</th>
                        <th>Weight</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{stoneNoData[0].stoneType}</td>
                        <td>{stoneNoData[0].pcs}</td>
                        <td>{stoneNoData[0].length}</td>
                        <td>{stoneNoData[0].width}</td>
                        <td>{stoneNoData[0].height}</td>
                        <td>{stoneNoData[0].weight?.toFixed(2)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {numOfRows > 0 && (
        <div className="card-body table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Index</th>
                <th>PCS</th>
                <th>Length</th>
                <th>Width</th>
                <th>Height</th>
                <th>
                  Total Weight: <span>{totalWeight.toFixed(2)}</span>
                </th>
              </tr>
            </thead>

            <tbody>
              {Array.from({ length: numOfRows }).map((_, rowIndex) => (
                <tr key={rowIndex} style={{ lineHeight: "10px" }}>
                  <td style={{ textAlign: "center" }}>{rowIndex + 1}</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id={`pcs-${rowIndex}`}
                      placeholder="PCS"
                      value={SplitASIList[rowIndex]?.pcs || ""}
                      onChange={(e) =>
                        handleRowInputChange(rowIndex, "pcs", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id={`length-${rowIndex}`}
                      placeholder="Length"
                      value={SplitASIList[rowIndex]?.length || ""}
                      onChange={(e) =>
                        handleRowInputChange(rowIndex, "length", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id={`width-${rowIndex}`}
                      placeholder="Width"
                      value={SplitASIList[rowIndex]?.width || ""}
                      onChange={(e) =>
                        handleRowInputChange(rowIndex, "width", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id={`height-${rowIndex}`}
                      placeholder="Height"
                      value={SplitASIList[rowIndex]?.height || ""}
                      onChange={(e) =>
                        handleRowInputChange(rowIndex, "height", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id={`weight-${rowIndex}`}
                      placeholder="Weight"
                      value={SplitASIList[rowIndex]?.weight || ""}
                      onChange={(e) =>
                        handleRowInputChange(rowIndex, "weight", e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="card-footer margin_top10">
        <button
          type="button"
          className="btn btn-primary"
          onClick={InsertSplitStone}
        >
          Save
        </button>
      </div>

      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <span>Split Stone List:</span>
          <div className="d-flex justify-content-center flex-grow-1">
            <Col md={6} lg={3} sm={12} className="my-0.5">
              <InputGroup className="PolicySelectDateInputGroup">
                <InputGroup.Text id="basic-addon1">From</InputGroup.Text>
                <Form.Control
                  type="date"
                  name="start_date"
                  value={dateData.start_date}
                  onChange={handleInputChange}
                  required
                />
              </InputGroup>
            </Col>
            <Col md={6} lg={3} sm={12} className="my-0.5 mx-2">
              <InputGroup className="PolicySelectDateInputGroup">
                <InputGroup.Text id="basic-addon1">To</InputGroup.Text>
                <Form.Control
                  type="date"
                  name="end_date"
                  value={dateData.end_date}
                  onChange={handleInputChange}
                  required
                />
              </InputGroup>
            </Col>
            <Button variant="primary" onClick={() => getSplitStone()}>
              <i className="fa fa-search"></i> Search
            </Button>
          </div>

          <button
            type="submit"
            className="btn btn-primary mb-0px"
            onClick={printSelectedRows}
          >
            Print
          </button>
          <div>
            <Button
              type="button"
              variant="success"
              className="btn btn-primary"
              onClick={exportToExcel}
              style={{ marginLeft: "10px" }}
            >
              <i className="fa fa-file-excel"></i> Export to Excel
            </Button>
          </div>
        </div>
        <div className="card-body">
          <AgGridComponent
            rowData={SplitStoneData}
            columnDefs={columnDefs}
            onSelectionChanged={handleCheckboxSelection}
            paginationPageSize={50}
            height="70vh"
          ></AgGridComponent>
        </div>
      </div>
    </div>
  );
}
